import LicenseDetail from '@/components/licenses/LicenseDetail.jsx';

export default function AgencyLicenseDetail() {
  return <LicenseDetail kind="agency" />;
}
